/** Public site URL — set REACT_APP_SITE_URL in Vercel for staging/production. */
export const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://www.dhhcollab.com').replace(/\/$/, '');

export const SITE_NAME = 'DHH Collab';

export const SITE_TAGLINE = 'Where Desi Hip-Hop Connects';

export const DEFAULT_DESCRIPTION =
  'DHH Collab is India\'s collaboration platform for Desi Hip-Hop (DHH). Producers upload beats, rappers record verses in the browser, and listeners vote — built for the Indian hip-hop community.';

export const DEFAULT_KEYWORDS =
  'DHH, Desi Hip Hop, Desi Hip-Hop, Indian Hip Hop, Indian hip-hop, hip hop collaboration India, beat upload, rap verses, producer rapper collab, DHH Collab, dhhcollab';

export const SUPPORT_EMAIL = 'dhhcollabops@gmail.com';

export const FOOTER_COPYRIGHT =
  '© 2026 DHH Collab. Platform rights reserved. Beats and verses remain the property of their creators.';

/** Absolute URL to the site icon (used in Open Graph / structured data). */
export const SITE_ICON_URL = `${SITE_URL}/logo512.png`;

export const FAQ_ITEMS = [
  {
    question: 'What is DHH Collab?',
    answer:
      'DHH Collab is an online platform where Desi Hip-Hop artists collaborate. Producers share beats, rappers record verses directly in the browser, and listeners discover and vote on tracks across India.',
  },
  {
    question: 'What does DHH mean?',
    answer:
      'DHH stands for Desi Hip-Hop — hip-hop music created by artists from India and the broader South Asian diaspora, blending local languages, culture, and sounds with rap and production.',
  },
  {
    question: 'Who is DHH Collab for?',
    answer:
      'Producers who want rappers on their beats, rappers looking for instrumentals, producer-rappers who do both, and listeners who want to explore and support Indian hip-hop.',
  },
  {
    question: 'How does collaboration work on DHH Collab?',
    answer:
      'Producers upload beats and set a verse limit. Rappers browse beats, record verses over them, and publish to the community. Listeners vote on beats and verses to surface what resonates.',
  },
  {
    question: 'Is DHH Collab free to join?',
    answer:
      'Yes. Create a free account to upload beats, record verses, or listen and vote. Sign up at dhhcollab.com/signup.',
  },
] as const;

export function absoluteUrl(path = '/'): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_URL}${normalized}`;
}
